import React, { useEffect } from 'react';

import { Grid } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import DnaKitInstructions from 'on_web/components/onboarding/dna/DnaKitInstructions';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import useUsersApi from '../hooks/useUsersApi';
import UserProfileContext from 'on_web/context/userProfileContext';

import {
  ROUTE_ONBOARDING_DNA,
  ROUTE_PCE_ONBOARDING_DNA,
  ROUTE_ONBOARDING_GENERAL,
  ROUTE_PCE_ONBOARDING_GENERAL,
} from 'routes';
import {
  getRedirectRoute,
  getRedirectRoutePce,
} from '../helpers/redirectHelper';

export default function OnboardingDnaKitInstructionsPage(props) {
  const context = React.useContext(UserProfileContext);
  const forPce = props.location.state && props.location.state.forPce;

  const [
    {
      response,
      loading,
      responseGenotype,
      loadingGenotype,
      getUserData,
      saveUserData,
      errorSaving,
      getGenotype,
      saveGenotype,
      deleteGenotype,
    },
  ] = useUsersApi();

  useEffect(() => {
    let userData;
    getUserData()
      .then(userDataResponse => {
        userData = userDataResponse;
        return getGenotype();
      })
      .then(genotypeResponse => {
        if (userData != null) {
          if (
            props.location.state &&
            !props.location.state.startFromLast &&
            userData.user_metadata.onboarding.dnaFinished
          ) {
            let route;
            if (forPce) {
              route = getRedirectRoutePce(userData.user_metadata);
            } else {
              route = getRedirectRoute(userData.user_metadata);
            }
            props.history.push({
              pathname: route,
              state: {
                forPce: true,
              },
            });
          }
        }
      });
  }, [getUserData, getGenotype]);

  const saveStep = userMetaData => {
    if (userMetaData) {
      response.user_metadata = userMetaData;
      saveUserData(response);
    }
  };

  const saveKitCode = dnaKitCode => {
    if (dnaKitCode) {
      const params = {
        gxgimport: {
          gxg_kit_number: dnaKitCode,
        },
      };

      deleteGenotype()
        .then(response => {
          return response;
        })
        .then(() => {
          return saveGenotype(params);
        });
    }
  };

  const onClickNext = () => {
    let userMetaData = response.user_metadata;
    userMetaData.onboarding.dnaFinished = true;
    saveUserData(userMetaData).then(() => {
      if (errorSaving == null) {
        props.history.push(
          forPce ? ROUTE_PCE_ONBOARDING_GENERAL : ROUTE_ONBOARDING_GENERAL
        );
      }
    });
  };

  return (
    <div>
      <Grid
        container={useMediaQuery('(min-width:1000px)')}
        direction="row"
        justify="center"
        alignItems="center"
      >
        {loading === false && response && loadingGenotype === false && (
          <UserProfileContext.Provider
            value={{
              userData: response,
              genotype: responseGenotype,
              showBasicQuestions: context.showBasicQuestions,
            }}
          >
            <PageItemContainer>
              <DnaKitInstructions
                onNewStep={userMetaData => saveStep(userMetaData)}
                onKitSubmit={dnaKitCode => saveKitCode(dnaKitCode)}
                onClickNext={() => onClickNext()}
                onClickBack={() =>
                  props.history.push({
                    pathname: forPce
                      ? ROUTE_PCE_ONBOARDING_DNA
                      : ROUTE_ONBOARDING_DNA,
                    state: {
                      startFromLast: true,
                    },
                  })
                }
                forPce={forPce}
              />
            </PageItemContainer>
          </UserProfileContext.Provider>
        )}
      </Grid>
    </div>
  );
}
